import React, { Component } from "react";

import { defined } from "@formant/core/common/defined";
import { IStream } from "@formant/core/model/IStream";

import { appStore, streamStore } from "../../../stores";
import { Buttons } from "../../common/Buttons";
import { ActionButton } from "../ActionButton";

export interface IActionsProps {
    stream: IStream;
}

export class Actions extends Component<IActionsProps> {
    public render() {
        return (
            <Buttons>
                <ActionButton
                    icon="delete"
                    onClicked={this.onDelete}
                    data-tooltip="Remove stream"
                />
            </Buttons>
        );
    }

    private onDelete = () => {
        const { stream } = this.props;
        const { streamName, id } = stream;
        appStore.setConfirm({
            title: "Delete stream",
            message: `Delete stream "${streamName}"?`,
            onOk: async () => {
                await streamStore.disable(defined(id));
                appStore.setSnackbar("Stream deleted");
            },
        });
    };
}
